<template>
    <div class="vod-footer">
        <div class="vod-footer-icons">
            <a href="https://www.facebook.com/livekidapp/" target="_blank">
                <img src="@/assets/img/logos/ic-facebook.svg" alt="" />
            </a>
            <a
                href="https://www.youtube.com/channel/UC5h_fgE9P1RWVSdmm8dIp_w/videos"
                target="_blank"
            >
                <img src="@/assets/img/logos/ic-youtube.svg" alt="" />
            </a>
            <a href="https://www.instagram.com/livekid_app/" target="_blank">
                <img src="@/assets/img/logos/ic-instagram.svg" alt="" />
            </a>
        </div>
        <div class="vod-footer-columns">
            <div class="vod-footer-column">
                <p>O LiveKid</p>
                <div>
                    System zarządzania żłobkiem lub przedszkolem w formie
                    wygodnej aplikacji, dzięki której zaoszczędzisz swój czas i
                    pieniądze, a prowadzenie placówki będzie o wiele łatwiejsze.
                </div>
            </div>
            <div class="vod-footer-column">
                <p>Obsługa klienta:</p>
                <div>
                    +48 736 920 797
                </div>
                <div>
                    hello@livekid.com
                </div>
            </div>
            <div class="vod-footer-column">
                <p>Dane firmy:</p>
                <div>
                    LiveKid Sp. z o.o.
                </div>
                <div>
                    ul. Energetyczna 6 lok. 7
                </div>
                <div>
                    53-330 Wrocław
                </div>
            </div>
        </div>
        <div class="vod-footer-addons">
            © 2017-2022 Livekid sp. z.o.o
        </div>
    </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scoped>
.vod-footer {
    width: 100%;
    padding: 2rem 15rem;
    padding-bottom: 5rem;
    color: #999999;

    img {
        margin-right: 1rem;
        cursor: pointer;
    }
}
.vod-footer-columns {
    margin-top: 1rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
}
.vod-footer-column {
    max-width: calc(100% / 3);
}
.vod-footer-columns {
    p {
        font-family: $input-family;
    }
    div {
        margin-bottom: 1rem;
    }
}
.vod-footer-icons {
    display: flex;
    align-items: center;
}
@media (max-width: 1000px) {
    .vod-footer {
        padding: 2rem 5rem;
        padding-bottom: 5rem;
        display: flex;
        flex-direction: column;
    }
    .vod-footer-column {
        max-width: 100%;
        width: 100%;
    }
}
</style>
